import HomeGallery from 'components/HomeGallery';

export default function Home() {
    return (
        <>
            <HomeGallery></HomeGallery>
        </>
    );
}